<div class="settings-panel animate-fade-in">
  <div class="loading-spinner" *ngIf="isCompanyLoading || businessAttributesLoading">
    <div class="cc-icon cc-icon-spinner"></div>
  </div>

  <form
    *ngIf="!isCompanyLoading"
    [hidden]="businessAttributesLoading"
    [formGroup]="form"
    (ngSubmit)="canSaveSettings && onSubmit()"
    novalidate
  >
    <div class="sm-flex sm-flex-col sm-gap-y-4">
      <h1 class="sm-text-xl sm-font-medium" i18n>General</h1>
      <div class="organisation-name-container">
        <label i18n for="name" class="sm-w-1/3">Name</label>
        <div class="sm-flex sm-w-2/3 sm-flex-col sm-gap-y-1">
          <cc-text-input
            data-test="company-name-input"
            [value]="form.get('name').value"
            placeholder="Type name"
            i18n-placeholder="Type name"
            name="name"
            id="name"
            [hasError]="form.get('name').touched && form.get('name').invalid"
            (onValueChanged)="changeOrgName($event)"
            (onBlur)="form.get('name').markAsTouched()"
          ></cc-text-input>
          <div
            *ngIf="form.get('name').invalid && form.get('name').touched"
            class="sm-text-default-red"
            [innerHTML]="form.get('name').errors.message | safeHtml"
          ></div>
        </div>
      </div>
      <cc-company-settings-business-attributes-selector
        [businessAttributes]="company?.businessAttributes"
        (onSelection)="onBusinessAttributesSelection($event)"
        (onLoad)="businessAttributesLoaded()"
      ></cc-company-settings-business-attributes-selector>

      <cc-company-domain-settings
        [domainModel]="domainModel"
        [isSuperAdmin]="isSuperAdmin"
        [model]="model"
      ></cc-company-domain-settings>

      <div class="sm-flex sm-flex-row sm-gap-x-2">
        <label i18n for="delete-account" class="sm-w-1/3"> Delete workspace </label>
        <div class="sm-w-2/3">
          <button
            type="button"
            [class.disabled]="!isSuperAdmin"
            class="delete-workspace button-red sm-rounded sm-p-2"
            data-test="delete-workspace"
            (click)="deleteWorkspace()"
          >
            Delete Workspace
          </button>
        </div>
      </div>

      <button
        type="submit"
        data-test="save-button"
        class="px-5 btn cc-btn-primary-constructive button-green sm-w-min sm-self-center"
        [class.disabled]="!canSaveSettings || isSaving"
      >
        Save
      </button>
    </div>
  </form>
</div>
